<template>
  <div id="app">

    <AppHeader/>

    <main class="content">
      <router-view/>
    </main>

    <AppFooter/>

  </div>
</template>

<script>
import AppHeader from "./components/layout/AppHeader.vue";
import AppFooter from "./components/layout/AppFooter.vue";

export default {
  name: 'App',

  components: {
    AppHeader,
    AppFooter
  },

  async created() {
    await this.$store.dispatch('fetchCompetitions');
    console.log(this.$store.state.competitions);
  }
}
</script>

<style lang="scss">
@import '@/assets/sass/variables';

* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  // اسکرول افقی در سطح صفحه ممنوع — جدول‌های پهن خودشون اسکرول داخلی دارن
  overflow-x: hidden;
}

#app {
  direction: rtl;
  width: 100%;
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;
}

/*
  کانتینر اصلی — سیستم ۴ حالته:
  دسکتاپ ≥1400 | لپ‌تاپ 1025–1399 | تبلت 769–1024 | موبایل ≤768
  ⚠️ این کانتینر «عرض درصدی + flex» نباید داشته باشد — عرض درصدی (70%) روی
  لپ‌تاپ صفحه را به‌هم می‌ریزد و flex باعث بیرون‌زدگی عرضی ویوها می‌شود
  (flex item با max-content عرض می‌گیرد). هر view خودش max-width و
  margin:auto دارد و اینجا فقط یک بلاک وسط‌چین تمام‌عرض کافی است.
*/
.content {
  width: 100%;
  max-width: 1448px; /* 1400 محتوای بیشینه + پدینگ دو طرف */
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
}

/* تبلت/لپ‌تاپ کوچک — نفس بیشتر برای محتوا */
@media (max-width: 1024px) {
  .content {
    padding: 0 16px;
  }
}

/* =========================
   Mobile
========================= */

@media (max-width: #{$mobile}) {

  .content {
    display: block;
    width: 100%;
    max-width: 100%;
    padding: 0 12px;

  }

}
</style>